import { getRouteApi } from '@tanstack/react-router';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { Button, Container, IconName, Stack } from '@optimus-web/core';

import { useUpdateActivityLog } from './activityLog/useUpdateActivityLog';
import { usePrivilegeUserCanEdit } from './useUserPrivilegeCanEdit';
import {
    createAuditSelect,
    getFinancialAndSpaces,
    getGuestExperience,
    getRevenueManagement,
    getServicesAndProducts,
} from './utils/utils';
import { GoLiveTaskTable } from './components/goLiveTaskTable/GoLiveTaskTable';

const SetupRoute = getRouteApi('/_authenticated/$currentEnterpriseId/Settings/GoLiveAudits/Setup');

export const GoLiveTasksContainer = () => {
    const { currentEnterpriseId } = SetupRoute.useParams();
    const userCanEdit = usePrivilegeUserCanEdit();

    const {
        data: { auditList, groupedAudits },
    } = useRepositorySuspenseQuery(
        'enterprises',
        'getOnboardingAudit',
        { enterpriseId: currentEnterpriseId },
        {
            refetchOnWindowFocus: 'always',
            select: createAuditSelect,
        }
    );

    const [renderUpdateActivityLogDialog, toggleUpdateActivityLogDialog] = useUpdateActivityLog({ auditList });

    return (
        <Container padding={['300', '0', '0', '0']}>
            <Stack vertical>
                <Stack spacing="0" itemAlignment="end" alignment="end">
                    {userCanEdit ? (
                        <>
                            <Button
                                icon={IconName.ActionLog}
                                size="small"
                                variant="tertiary"
                                type="button"
                                onClick={toggleUpdateActivityLogDialog}
                            >
                                {lt('GoLiveAuditsUpdateActivityLog')}
                            </Button>
                            {renderUpdateActivityLogDialog()}
                        </>
                    ) : null}
                </Stack>
                <Stack vertical spacing="400">
                    <GoLiveTaskTable
                        audits={getFinancialAndSpaces(groupedAudits)}
                        title={lt('OnboardingAuditFinancialSpacesTableHeader')}
                    />
                    <GoLiveTaskTable
                        audits={getServicesAndProducts(groupedAudits)}
                        title={lt('OnboardingAuditServicesAndProductsTableHeader')}
                    />
                    <GoLiveTaskTable
                        audits={getRevenueManagement(groupedAudits)}
                        title={lt('OnboardingAuditRevenueManagementTableHeader')}
                    />
                    <GoLiveTaskTable
                        audits={getGuestExperience(groupedAudits)}
                        title={lt('OnboardingAuditGuestExperienceTableHeader')}
                    />
                </Stack>
            </Stack>
        </Container>
    );
};
